import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';
import { LocalForm } from 'react-redux-form';

import Header from '../HeaderNoLogout';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import { HashLink as Link } from 'react-router-hash-link';
import viewstmIcon from './assets/viewstm.png';
import userinvitationIcon from './assets/userinvitation.png';
import usermanagementhomeIcon from './assets/usermanagementhome.png';
import letterIcon from './assets/letter.jpg';
import viewgraphicIcon from './assets/viewgraphic.png';
import viewtablespecIcon from './assets/viewtablespec.png';
import viewsourcecodeIcon from './assets/viewsourcecode.png';
import viewcolumnmappingsIcon from './assets/viewcolumnmappings.png';
import viewtablemappingsIcon from './assets/viewtablemappings.png';
import customeronboardingIcon from './assets/customeronboarding.png';
import phoneIcon from './assets/phone.jpg';
import arrowIcon from './assets/arrow.jpg';
import homepageIcon from './assets/homepage.png';
import mydatafactoryhomeIcon from './assets/mydatafactoryhome.png';
import createprojectIcon from './assets/createproject.png';
import gitlabIcon from './assets/gitlab.jpg';
import createdatafactoryIcon from './assets/createdatafactory.png';
import addusertodfIcon from './assets/addusertodf.png';
import projectmanagementhomeIcon from './assets/projectmanagementhome.png';
import uploadddlfilesIcon from './assets/uploadddlfiles.png';
import uploadhiveddlfilesIcon from './assets/uploadhiveddlfiles.png';
import Panellogout from '../../elements/Panellogout';
import Panelright from '../../elements/Panelright';
import './Help.css';
import './Help.scss';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'term.use.html.header1',
    description: 'Page Header Title',
    defaultMessage: 'User Guide'
  },
  headerSubTitle: {
    id: 'translation.header.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Upload files for translation.'
  }
});

class Help extends Component {
  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.clickTOPHandler = this.clickTOPHandler.bind(this);
    this.state = {
      show: false
    }
  }
  componentDidMount() {
    if(this.state.show){
      this.setState({show:false});
    }
}

clickTOPHandler= () => {
    this.setState({show:false});
  };

  render() {
    return (
      <div className="preview pagehelp">
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          icon="preview"
          locale={this.props.locale}
          status = {this.props.status}
        />
        <div id="header"></div>
        <div className="main" >
          <div className="panels">
           <Panellogout  style={{top: '162px',left: '15px',overflow:'auto'}}
                header={
                  <h3>
                    <FormattedMessage
                      id="content.panel.title"
                      defaultMessage="Table2 of Contents"
                    />
                  </h3>
                }
              >
            <div className="form" >
              <label
                style={{
                  width: '90%',
                  //fontSize: '14px',
                  textTransform: 'none',
                  lineHeight: '150%',
                  color: '#797979'
                }}
              >
                {/*<div className="text" style={{color:'#1f5c71',fontSize: '16px',position:'fixed',top: '162px',left: '15px'}} >*/}
                <div className="text" style={{color:'#1f5c71',fontSize: '16px'}} >
                <Link to="/en-CA/help#header" style={{color:'#1f5c71',textDecoration:'none'}}  className='text'>
                  Chapter 1 - FUSE
                </Link>
                <br/><br/>

                <Link to="/en-CA/help#Chapter2" style={{color:'#1f5c71',textDecoration:'none'}} >Chapter 2 - Technical Support	</Link>
                <br/><br/>

                <Link to="/en-CA/help#Chapter3" style={{color:'#1f5c71',textDecoration:'none'}} >Chapter 3 - How to Register & Login for FUSE	</Link>
                   <li style={{color:'rgb(94, 122, 43)'}}><Link to="/en-CA/help#usermanagement" style={{color:'#1f5c71',textDecoration:'none',marginLeft:'0px',fontSize:'14px'}} >User Management	</Link></li>
                  <li style={{color:'rgb(94, 122, 43)'}}><Link to="/en-CA/help#userinvitation" style={{color:'#1f5c71',textDecoration:'none',marginLeft:'0px',fontSize:'14px'}} >User Invitation	</Link></li>
                  <li style={{color:'rgb(94, 122, 43)'}}><Link to="/en-CA/help#changepassword" style={{color:'#1f5c71',textDecoration:'none',marginLeft:'0px',fontSize:'14px'}} >Reset your password </Link></li>
                  <br/>

              <Link to="/en-CA/help#Chapter4" style={{color:'#1f5c71',textDecoration:'none'}}>Chapter 4 - My Data Factory	</Link>
              <li style={{color:'rgb(94, 122, 43)'}}><Link to="/en-CA/help#Chapter4" style={{color:'#1f5c71',textDecoration:'none',marginLeft:'0px',fontSize:'14px'}}>Your Home Page </Link></li>
              <li style={{color:'rgb(94, 122, 43)'}}><Link to="/en-CA/help#createdatafactory" style={{color:'#1f5c71',textDecoration:'none',marginLeft:'0px',fontSize:'14px'}}>Create/Update Data Factory</Link></li>
              <li style={{color:'rgb(94, 122, 43)'}}><Link to="/en-CA/help#addingusers" style={{color:'#1f5c71',textDecoration:'none',marginLeft:'0px',fontSize:'14px'}}>Add Users to Your Data Factory	</Link></li>
              <li style={{color:'rgb(94, 122, 43)'}}><Link to="/en-CA/help#managingddlfiles" style={{color:'#1f5c71',textDecoration:'none',marginLeft:'0px',fontSize:'14px'}} >Upload DDL Files	</Link></li>
              <li style={{color:'rgb(94, 122, 43)'}}><Link to="/en-CA/help#managingprojects" style={{color:'#1f5c71',textDecoration:'none',marginLeft:'0px',fontSize:'14px'}}>Manage Data Pipeline Projects	</Link></li>
                  <br/>

              <Link to="/en-CA/help#Chapter5" style={{color:'#1f5c71',textDecoration:'none'}} >Chapter 5 - Data Pipeline Project Management	</Link>
              <li style={{color:'rgb(94, 122, 43)'}}><Link to="/en-CA/help#Chapter5" style={{color:'#1f5c71',textDecoration:'none',marginLeft:'0px',fontSize:'14px'}}>Create/Update a Data Pipeline Project</Link></li>
              <li style={{color:'rgb(94, 122, 43)'}}><Link to="/en-CA/help#viewstm" style={{color:'#1f5c71',textDecoration:'none',marginLeft:'0px',fontSize:'14px'}} >View STM	</Link></li>
              <li style={{color:'rgb(94, 122, 43)'}}><Link to="/en-CA/help#viewdatapipeline" style={{color:'#1f5c71',textDecoration:'none',marginLeft:'0px',fontSize:'14px'}} >View Data Pipeline Design	</Link></li>
              <li style={{color:'rgb(94, 122, 43)'}}><Link to="/en-CA/help#viewsourcecode" style={{color:'#1f5c71',textDecoration:'none',marginLeft:'0px',fontSize:'14px'}} >View Data Pipeline Source Code	</Link></li>
              <br/>
              </div>
               </label>
            </div>

          </Panellogout>

        <Panelright>
          <div id= "Chapter1"/>
          <LocalForm style={{}}  >
                    <div className="form" >
                      <label
                        style={{
                          width: '91%',
                          //fontSize: '14px',
                          textTransform: 'none',
                          //lineHeight: '150%',
                          color: '#797979',
                          overflowY: '',
                          paddingleft:'10px'
                        }}
                      >
                      <div  style={{float:'right'}}>
                        <section style={{backgroundColor:'#5e7a2b',color: '#fff',textAlign:'center',height:'59px', width:'78px',paddingTop:'10px'}}>
  Chapter <br/><span>1</span></section>

</div> <br/><br/>
<div style={{       color:'#1f5c71',
                    width: '90%',
                    fontSize: '25px'}}>Chapter 1 – FUSE
</div>
 <br/>
<div><p>FUSE is a cloud based ETL service offered through SaaS (Software as a Service) by Next Pathway. FUSE accelerates cloud data migration by automating ETL data pipeline code generation for various big data processing platform such as Spark, AWS Glue, GCP Cloud Dataflow, Databricks, and Azure ADF. FUSE allows users to generate their data pipelines simply based on the data model and the source to target mappings (STM) design without a single line of coding, thus makes it easier to prepare and load your data from various sources of cloud based or on-premise applications for your data analytics. FUSE’s automated ETL code generation capability allows users to move their focuses on their analytics data modelling, design and testing instead of wasting effort on manually writing code for ETL, thus improve data pipeline code and data quality.</p>
<br/>

</div>
<br/><br/><br/>

<div id='Chapter2'/>
<div id='support'   style={{float:'right'}}>
  <div style={{backgroundColor:'#5e7a2b',color: '#fff',textAlign:'center',height:'59px', width:'78px',paddingTop:'10px'}}>
     Chapter <br/><span>2</span>
  </div>

</div> <br/><br/>
<div style={{color:'#1f5c71',width: '90%',fontSize: '25px'}}>
                    Chapter 2 – Technical Support
</div>   <br/>
<div>
  <table><tbody>
<tr id='letter'>

<td style={{width: '72%'}}></td>
<td style={{width: '28%'}}>
</td>
</tr>
<tr>

<td style={{width: '72%'}}>
<p>FUSE is supported by Next Pathway’s FUSE<sup>TM</sup> team.</p><br/>
<p><b>Our hours of support are: 9:00 AM to 6:00PM ET, Monday to Friday.</b></p><br/>
<p>You can reach the FUSE team through email {'  '}
<a href="mailto:fuse_support@nextpathway.com" style={{color:'#1f5c71'}}>fuse_support@nextpathway.com</a>
</p>
<p>The target <i style={{textDecoration: "underline"}}>response</i> time is 60 minutes (during Business Hours).</p>
<p>The target <i style={{textDecoration: "underline"}}>resolution</i> time is 8 Business Hours (non-code issues) and 7 Business Days (code issues).</p>
  <p>FUSE resides on Next Pathway’s cloud infrastructure.  During the translation, no client code will leave Next Pathway's infrastructure.</p>
</td>
<td style={{width: '28%'}}>
<span style={{textAlign:'right',color: 'rgb(94, 122, 43)',float:''}}>FUSE SUPPORT</span><br/>
<img  alt="" src={letterIcon} style={{
                      width: '20px',
                      float: 'left',
                      hight:'20px'

                    }}/>

<a href="mailto:fuse_support@nextpathway.com" style={{color:'#1f5c71',float:'right',width:'91%'}}>fuse_support@nextpathway.com</a>
  <br/>
  </td>
</tr>

</tbody></table>
</div>
<br/>

<div id='Chapter3'/>

<div style={{color:'#1f5c71',width: '90%',fontSize: '25px', visibility: 'hidden'}}>
   Chapter 3
</div>
<div style={{float:'right'}}>
  <section style={{backgroundColor:'#5e7a2b',color: '#fff',textAlign:'center',height:'59px', width:'78px',paddingTop:'10px'}}>
     Chapter <br/><span>3</span>
  </section>

</div> <br/><br/>
<div style={{color:'#1f5c71',width: '90%',fontSize: '25px'}}>
          Chapter 3 - How to Register & Login for FUSE
</div>   <br/>
<div>
  <p>
    To register for FUSE, at the Login Page, click Register Customer Account. This will take you to a New Customer Onboarding page where you can enter your information and register your organization account. Once your registration gets approved, you will be assigned as FUSE Administrator for your organization, then you can log into FUSE and invite the other users of your organization to use FUSE.
  </p>
  <br/>
  <div>
    <img alt="" src={homepageIcon} style={{
      width: '520px',
      float: 'center',
      hight:'520px',
      paddingleft:'100px !important'
    }}/>
  </div>
  <br/>

  </div>

  <br/>
  <br id='usermanagement'/><br/>

  <div>
    <br/><br/>
  <label style={{fontsize:'16px'}}>User Management </label>
  <p>
  As the FUSE administrator of your organization, you can invite/delete/reactivate a user from your organization. You can also change role of another person from your organization be the administrator when you are away.
  </p>
  <br/>
  <div>
    <img alt="" src={usermanagementhomeIcon} style={{
      width: '520px',
      float: 'center',
      hight:'520px',
      paddingleft:'100px !important'

    }}/>
  </div>
  </div>
  <br/>
  <br id='userinvitation'/><br/>

    <div>
    <label style={{fontsize:'16px'}}>Invite User </label>
    <p>As the FUSE Administrator, you can invite a user from your organization to access FUSE by providing her/his contact information and assign him/her a role as either a project lead or a regular user. A notification email will be sent to her/him with a temporary password.
                              </p>
                              <br/>
                              <div>
                                <img alt="" src={userinvitationIcon} style={{
                                  width: '520px',
                                  float: 'center',
                                  hight:'520px',
                                  paddingleft:'100px !important'

                                }}/>
                              </div>
                              <br/>

    <p>Once the user receives the <b>FUSE User Invitation email</b>, she/he can click the link to the FUSE Portal in the email to <b>Sign In</b>. After first Signing In with a temporary password, the user will be prompted review and accept the end user license agreement and also ask you to change your password.  </p>
    </div>
  <br id='changepassword'/><br/>
  <div >
    <br/><br/>
  <label style={{fontsize:'16px'}}>Reset your password </label>
   <p>If you forget your password, click on the link “<b>Forgot your password?</b>” and you will be prompted to reset your password by your email address.</p>
    <br/><br/>
  </div>

                        <br/><br/>
                        <br/><br/>
                        <div id='Chapter4'/>

                        <div   style={{float:'right'}}>
                          <section style={{backgroundColor:'#5e7a2b',color: '#fff',textAlign:'center',height:'59px', width:'78px',paddingTop:'10px'}}>
                             Chapter <br/><span>4</span>
                          </section>
                        </div>
                                          <br/><br/>
                        <div style={{color:'#1f5c71',width: '90%',fontSize: '25px'}}>Chapter 4 – My Data Factory</div>
                        <br/>
                        <label style={{fontsize:'16px'}}>Your Home Page </label>
                        <div>
                        <p>Once you successfully login, "My Data Factory" page is your home page. If you are a project lead of your organization, all data factories which you own or which you were added into by others are listed. However, if you are a regular user, you will only see a list of data factories which you were added into by those data factories' owners. </p>
                          <p>FUSE data factory is created and maintained for delivering ETL data pipeline projects. As an organization’s project lead user, you can create your own data factory by selecting the data factory type, versions, target language, and then adding connectors to SQL/NoSQL data sources.
                          </p>
                                  <img alt="" src={mydatafactoryhomeIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                          <br /><br />
                        </div>
                        <br /><br />
                        <label id ='createdatafactory' style={{fontsize:'16px'}}>Create/Update a Data Factory</label>
                        <div>

                        <p>Click "Create" or "Update" button in your data factory management home page, you can create or update your data factory. </p>
                                  <img alt="" src={createdatafactoryIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                      <p>1. Specify your new data factory by filling the information required in the screenshot.
                      </p><p>2. Add all connectors for your SQL/NoSQL data source.
                      </p><p>3. Click “Submit”, your data factory will be created successfully.
                      </p>
                                  </div>
                        <br /><br />
                        <label id ='addingusers' style={{fontsize:'16px'}}>Add Users to your Data Factory</label>
                        <div>

                        <p>As a project lead of a data factory, you can add users from your organization to your data factory so that they can create and manage data pipeline projects within your data factory. Click Manage Users button, you can add users to your data factory. </p>
                                  <img alt="" src={addusertodfIcon} style={{
                                                        float: 'center',
                                                        paddingleft:'100px !important'

                                                      }}/>
                                  </div>
                         <br /><br />
                        <label id ='managingddlfiles' style={{fontsize:'16px'}}>Upload DDL Files</label>
                        <div>

                        <p>You can upload DDL files to FUSE for validating your mapping and the code generated, and also support the development unit test cases. If you have defined a Spark data factory, you will be allowed to upload DDL files for Hive tables. If you have added SQL/NoSQL data sources for your data factory, you will be allowed to upload DDL files for each of them.
                          </p><p>The DDL files are mandatory for FUSE to validate your STM and the mapping design for your date pipeline projects and also the date pipeline code generated by FUSE.
                          </p>
                                  <img alt="" src={uploadhiveddlfilesIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                          <br /><br /><p>To upload your Hive tables DDL file, drag or click to browse it. If it’s valid it will be immediately uploaded. You can download the existing DDL file you uploaded previously before you upload another version.
                          </p><p>If you have SQL/NoSQL data sources added to your data factory, you can click Next button to upload/update the DDL file for each of them.
                          </p>
                                  <img alt="" src={uploadddlfilesIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                                  </div>
                        <br /><br />
                        <label id ='managingprojects' style={{fontsize:'16px'}}>Manage Data Pipeline Projects</label>
                        <div>

                        <p>In the My Data Factory page, you can select a data factory and click "Manage Projects" button to enter Data Pipeline Management home page to manage your data pipeline projects. </p>

                                  </div>
                        <div id='Chapter5' />
                        <br /><br />
                        <div  style={{float:'right'}}>
                          <section style={{backgroundColor:'#5e7a2b',color: '#fff',textAlign:'center',height:'59px', width:'78px',paddingTop:'10px'}}>
                             Chapter <br/><span>5</span>
                          </section>

                        </div> <br/><br/>
                        <div style={{color:'#1f5c71',width: '90%',fontSize: '25px'}}>
                                            Chapter 5 - Data Pipeline Project Management
                        </div>
                        <br />
                        <label id ='createproject' style={{fontsize:'16px'}}>Create/Update a Data Pipeline Project</label>
                        <div>

                        <p>In project management home, you can create a data pipeline project or update an existing one within a selected data factory. </p>
                                  <img alt="" src={projectmanagementhomeIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                        <br/><br/><p>1.	Click “CREATE” to create a project, or click “UPDATE” to make any modification to the information of a project.</p>
                                  <img alt="" src={createprojectIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                        <br/><br/><p>2.	Complete the information required of the new data pipeline project such as:</p>
                         <ul style={{ marginLeft: 40 }}>
                          <li>Data Factory Name - read-only data factory in which this data pipeline project is created</li>
                          <li>Project Name - the name of the data pipeline project</li>
                          <li>Application Name - the name of the application of the data pipeline</li>
                          <li>Source to Target file (STM File) - an excel spreadsheet file which documents the source to target table mappings and column mappings with their associated data transformation rules. This is the requirement for generating data pipeline source code and unit test cases.</li>
                          <li>Current Version - the current version of the STM file starting from 1.0</li>
                          <li>Comments or a description - the optional description for the data pipeline project</li>
                         </ul>
                                  </div>
                              <br/><br/>
                        <label id ='viewstm' style={{fontsize:'16px'}}>View STM</label>
                        <div>

                        <p>In project management home, you can click “VIEW STM” and view the existing latest version’s STM for a selected data pipeline project within a data factory.</p>
                                  <img alt="" src={viewstmIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                        <br/>
                                  </div>
                              <br/><br/>
                        <label id ='viewdatapipeline' style={{fontsize:'16px'}}>View Data Pipeline Design</label>
                        <div>

                        <p>In project management home, you can click “VIEW DATA PIPELINE” and view the latest version’s data pipeline design diagram and its associated technical mapping sheet for a selected data pipeline project within a data factory. In the Data Pipeline View, you can also print the diagram for technical specification sheets, or even download a zipped package of the diagram and technical specification sheets.</p>
                                  <img alt="" src={projectmanagementhomeIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                        <br/><br/>
                        <p>1.	After clicking “VIEW DATA PIPELINE”, the graphic view of the data pipeline, i.e. the diagram will be displayed.</p>
                                  <img alt="" src={viewgraphicIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                                                      <br/><br/>
                        <p>2.	If you would like to review the tables’ specification, click the button “TABLE SPECIFICATION”.</p>
                                  <img alt="" src={viewtablespecIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                                                      <br/><br/>
                       <p> 3.	If you would like to check the table level’s mapping specifications, click the button “TABLE MAPPING SPECIFICATION”.</p>
                                  <img alt="" src={viewtablemappingsIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                                                      <br/><br/>
                       <p>4.	If you want to check deeper details on column mappings, click on “COLUMN SPECIFICATION”.</p>
                                  <img alt="" src={viewcolumnmappingsIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                                                      <br/><br/><br/>
                                  </div>
                 <label id ='viewsourcecode' style={{fontsize:'16px'}}>View Data Pipeline Source Code</label>
                        <div>

                        <p>In project management home, you can click “VIEW SOURCE CODE” and view the latest version’s data pipeline source code release for a selected data pipeline project within a data factory.</p>
                                  <img alt="" src={viewsourcecodeIcon} style={{
                                                        width: '520px',
                                                        float: 'center',
                                                        hight:'520px',
                                                        paddingleft:'100px !important'

                                                      }}/>
                        <br/>
                                  </div>
                              <br/><br/>
                      </label>
                    </div>
               </LocalForm>
            </Panelright>
         </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default injectIntl(Help);



// WEBPACK FOOTER //
// ./src/components/views/Help/index.js